import {Button, Stack} from "@mui/material";
import pleshDark from "../../../theme/pleshDark";
import React from "react";
import axios from "axios";
import {API_URL, TOOLPRESS_API} from "../../../config";
import {useParams} from "react-router-dom";

const LinksQuestion = ({risposte: links, elementId}) => {
    const {eventOwnerId, id} = useParams()

    return (
        <Stack mt={3} alignItems={'center'} spacing={2} px={3}>
            {links.map((link, i) => (
                <Button variant={'contained'} href={link.url} target={'_blank'}
                        onClick={() => {
                            axios.post(`${API_URL}updatelinkcounter/${eventOwnerId}/${id}/${elementId}`, {linkIndex: i})
                              .then(() => {console.log("updated")})
                              .catch((error) => {console.log("LinksQuestion > error: ", error)})
                        }}
                        fullWidth
                        sx={{
                            textAlign:'center',
                            minHeight: '60px',
                            fontWeight: 'bold',
                            borderRadius: '1rem',
                            background: '#B7DAF4',
                            fontFamily:'Patrick HandSC',
                            color:'#293557',
                            lineHeight:1
                        }}
                >
                    {link.label}
                </Button>
            ))}
        </Stack>
    )
}

export default LinksQuestion